import { Component, OnInit, ViewChild } from '@angular/core';
import { ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdLoadingService, IPageChangeEvent, ITdDataTableSortChangeEvent, TdDialogService, TdSearchBoxComponent } from '@covalent/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { LocationService } from 'services/location.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { BranchService } from '../../accounting/branches/branch.service';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../accounting/branch';
import { Location } from '../../accounting/location';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: any[];

  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';

  columns: ITdDataTableColumn[] = [
    { name: 'name', label: 'Location' },
    { name: 'branch', label: 'Branch' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;

  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: MdDialog,
    private _quickDialog: TdDialogService,
    private _loadingService: TdLoadingService,
    private _locationService: LocationService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this._locationService.getLocations().subscribe(
      response => {
        this.data = response.filter(
          (l: Location) => {
            return this._authService.getUserBranches().some(
              (b: Branch) => {
                return l['branch_id'] == b.id;
              }
            );
          }
        );
      },
      error => {
        this._loadingService.resolve('loading');
        console.log(error)
      },
      () => {
        this._loadingService.resolve('loading');
        this.filter();
      }
    );

    //Use user's branches instead
    //this.allBranches$ = this._locationService.getBranches();
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('location')) {
      this._searchBox.value = this._settingsService.getSearchTerm('location');
      this._searchBox.searchClicked();
    }
  }

  openAddNewLocationDialog() {
    this._dialogService.open(NewLocationDialog).afterClosed().subscribe(
      result => {
        if (result != null) {
          this.data.push(result);
          this.filter();
        }
      }
    );
  }

  deleteSelected() {
    this._loadingService.register('loading');

    this.selectedRows.forEach(
      (location) => {
        this._locationService.removeLocation(location.id).subscribe(
          response => {
            if (response['status'].toUpperCase() == 'SUCCESS') {
              this.data = this.data.filter(function (c) { return c['id'] != response['id'] });
            } else {
              console.log('Could not delete ' + location.name);
            }
          },
          error => {
            console.log(error);
          },
          () => {
            this._loadingService.resolve('loading');

            this.filter();
          }
        );
      }
    );

    this.selectedRows = [];
  }

  openNameChangeDialog(row) {
    this._quickDialog.openPrompt({
      title: 'Update Value',
      message: 'Enter new Location Name',
      value: row['name']
    }).afterClosed().subscribe(
      (value: string) => {
        this._loadingService.register('loading');

        if (value !== undefined) {
          this._locationService.updateLocationName(row['id'], value).subscribe(
            response => {
              if (response['status'] == 'SUCCESS') {
                row['name'] = value;
                this.filter();
              } else {
                this._quickDialog.openAlert({
                  title: 'Failed!',
                  message: 'Failed setting the New name'
                });
              }
            },
            error => {
              this._quickDialog.openAlert({
                title: 'Error!',
                message: 'Error setting the new name: ' + error
              });
            },
            () => {
              this._loadingService.resolve('loading');
            }
          );
        } else {
          this._loadingService.resolve('loading');
        }
      });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    if (this.sortBy == 'branch') this.sortBy += '_code';

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
    ? TdDataTableSortingOrder.Descending
    : TdDataTableSortingOrder.Ascending;
    
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('location', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;

    //this.pageSize = pagingEvent.pageSize;
    this._settingsService.setPageSize(pagingEvent.pageSize);

    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('location'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }
}




@Component({
  selector: 'new-location-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <h4>Enter new location and Branch</h4>
      <md-divider></md-divider>
      <md-input-container>
        <input mdInput type="text" placeholder="Location Name" [(ngModel)]="name">
      </md-input-container>
      <md-select fxFlex="22%" placeholder="Branch" [(ngModel)]="branch_id">
        <md-option *ngFor="let branch of branches" [value]="branch.id">{{branch.name}}</md-option>
      </md-select>
      <div flex layout="row" layout-wrap layout-margin>
        <button flex md-raised-button color="primary" class="bg-blue color-white" (click)="addLocation()">Add</button>
        <button flex md-raised-button color="primary" class="bg-blue color-white" (click)="dialogRef.close()">Close</button>
      </div>
    </div>
  `,
})
export class NewLocationDialog implements OnInit {
  branches: any[] = [];

  name: string = '';
  branch_id: number = 0;

  constructor(public dialogRef: MdDialogRef<NewLocationDialog>,
    private tdDialog: TdDialogService,
    private _locationService: LocationService,
    public _authService: AuthenticationService,
    private _branchService: BranchService) { }

  ngOnInit() {
    // Limit to user's branches
    this.branches = this._authService.getUserBranches();
    /*
    this._branchService.getBranches().subscribe(
      response => {
        this.branches = response;
      },
      error => {
        console.log(error)
      },
      () => { }
    );
    */
  }

  addLocation() {
    this._locationService.addLocation({ name: this.name, branch_id: this.branch_id }).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.tdDialog.openAlert(
            {
              title: 'Success!',
              message: 'Location added successfully'
            }
          );

          // Find the branch data
          let _branch: any = this.branches.find((b) => { return b.id == this.branch_id });

          this.dialogRef.close({ name: this.name, branch_id: this.branch_id, branch_code: _branch.code, branch_name: _branch.name });
        } else {
          this.tdDialog.openAlert(
            {
              title: 'Failed!',
              message: 'Could not add location'
            }
          );
          this.dialogRef.close();
        }
      },
      error => {
        this.tdDialog.openAlert(
          {
            title: 'Error!',
            message: 'An error occurred. Try again later.'
          }
        );
        this.dialogRef.close();
      },
      () => {

      }
    );

  }
}




// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/admin/location/location.component.ts